import { useState } from "react";
import { useQuery } from "react-query";

import { minutesToMilliseconds } from "date-fns";
import { Bundle } from "@prisma/client";

import { API_ROUTES } from "config/routes";

import { mapURLSearchParams } from "utils/query";

import fetcher from "lib/fetchJson";

const useStoresProducts = (storeId: number) => {
  const limit = 16;
  const [page, setPage] = useState(1);

  const { data, isLoading, isFetching, isError } = useQuery({
    queryKey: ["storeProducts", { limit, id: storeId, page }],
    queryFn: async () => {
      const params = mapURLSearchParams({
        limit,
        page: page,
        "filters[storeId]": storeId,
      });

      const response = await fetcher<{
        data: Bundle[];
        page: number;
        limit: number;
        totalPages: number;
        total: number;
      }>(`${API_ROUTES.STORE_BUNDLES}?${params}`);

      return {
        items: response.data,
        totalPages: response.totalPages,
        total: response.total,
        currentPage: page,
      };
    },
    staleTime: minutesToMilliseconds(15),
    keepPreviousData: true,
  });

  const handleChangePage = (_: unknown, page: number) => {
    window.scrollTo(0, 0);
    setPage(page);
  };

  return {
    pagination: {
      totalItems: data?.total,
      totalPages: data?.totalPages,
      limit,
      page: data?.currentPage,
    },
    products: data?.items || [],
    isProductsLoading: isLoading || isFetching,
    isProductsError: isError,
    handleChangePage,
  };
};

export default useStoresProducts;
